import { Dispatch, Action } from 'redux'
import { ToNextCycleButtonMapDispatchReturnType } from './types/ToNextCycleButtonMapDispatchReturnType'
import { createSubmitAction } from '../../../actionCreators/submit/Submit/createSubmitAction'
import { SUBMIT_MOVE_TASK_TO_CYCLE } from '../../../actions'

export const ToNextCycleButtonMapDispatch = (
  dispatch: Dispatch<Action>
): ToNextCycleButtonMapDispatchReturnType => {
  return {
    moveToNextCycle: (taskId) => {
      dispatch(
        createSubmitAction({
          type: SUBMIT_MOVE_TASK_TO_CYCLE,
          values: {
            cycle: 'next',
            taskId,
          },
        })
      )
    },
  }
}
